import { TipoFirma } from '../models/firmante-nif';

export interface ResumenFirmaTarjetaParams {
  tipo: TipoFirma | null | undefined;
  tieneTag?: boolean | null;
  nombreTag?: string | null;
  posicionFirmasCount?: number;
}

const SEPARADOR = ' - ';

export function resumenFirmaTarjeta({
  tipo,
  tieneTag,
  nombreTag,
  posicionFirmasCount = 0,
}: ResumenFirmaTarjetaParams): string {
  if (!tipo) {
    return '';
  }
  if (tipo === TipoFirma.Validador) {
    return 'Validador';
  }
  if (tipo === TipoFirma.SinFirma) {
    return 'Sin firma';
  }

  const etiquetaTipo = tipo === TipoFirma.Certificado ? 'Certificado' : 'Dibujada';

  if (tieneTag === true) {
    const tag = nombreTag?.trim();
    return tag
      ? `${etiquetaTipo}${SEPARADOR}Tag: ${tag}`
      : `${etiquetaTipo}${SEPARADOR}Mediante tag`;
  }
  if (posicionFirmasCount > 0) {
    return `${etiquetaTipo}${SEPARADOR}trazo`;
  }
  return `${etiquetaTipo}${SEPARADOR}trazar`;
}